import bebidasCalientes from '../../realizarPedido/assets/bebidasCalientes.png';
import bebidasFrias from '../../realizarPedido/assets/bebidasFrias.png';
import complementos from '../../realizarPedido/assets/complementos.png';
import hamburguesas from '../../realizarPedido/assets/hamburguesas.png';
import informacion from '../../realizarPedido/assets/i.png';
import eliminar from '../../realizarPedido/assets/eliminar.png';
import editarProductCard from '../../../../img/iconos/editar.png'
import editarImagen from '../assets/editarIcon.png';
import copy from '../assets/copy.png';
import camara from '../assets/addProduct.png'
// eslint-disable-next-line
export default {
  bebidasCalientes,
  bebidasFrias,
  complementos,
  hamburguesas,
  informacion,
  editarProductCard,
  eliminar,
  editarImagen, 
  camara,
  copy
};
